import { render } from "./tabs-snippet.vue?vue&type=template&id=103379b9"
import script from "./tabs-snippet.vue?vue&type=script&lang=js"
export * from "./tabs-snippet.vue?vue&type=script&lang=js"

import "./tabs-snippet.vue?vue&type=style&index=0&id=103379b9&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__